import { lazy, Suspense } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import Loader from "../components/Loader";
import GuestGuard from "../guards/GuestGuard";
import AuthGuard from "../guards/AuthGuard";
import AdminLayout from "../pages/Layout/AdminLayout";
const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  return useRoutes([
    // {
    //   path: '/',
    //   element: (
    //     <GuestGuard>
    //       <HomeLayout />
    //     </GuestGuard>
    //   ),
    //   children: [
    //     {
    //       path: '/',
    //       element: (
    //         <GuestGuard>
    //           <Home />
    //         </GuestGuard>
    //       ),
    //     },

    //   ],
    // },

    {
      path: "/",
      element: (
        <GuestGuard>
          <AdminLayout />
        </GuestGuard>
      ),
      children: [
        {
          path: "/",
          element: (
            <GuestGuard>
              <HomePage />
            </GuestGuard>
          ),
        },
        {
          path: "/products",
          element: (
            <GuestGuard>
              <ProductPage />
            </GuestGuard>
          ),
        },
        {
          path: "/categories",
          element: (
            <GuestGuard>
              <CategoryPage />
            </GuestGuard>
          ),
        },
        {
          path: "/orders",
          element: (
            <GuestGuard>
              <OrderPage />
            </GuestGuard>
          ),
        },
      ],
    },
    // {
    //   path: "admin",
    //   element: (
    //     <AuthGuard>
    //       <AdminLayout />
    //     </AuthGuard>
    //   ),
    //   children: [
    //     {
    //       path: "/admin/dashboard",
    //       element: (
    //         <AuthGuard>
    //           <Dashboard />
    //         </AuthGuard>
    //       ),
    //     },
    //   ],
    // },

    {
      path: "*",
      children: [
        { path: "404", element: <NotFound /> },
        { path: "*", element: <Navigate to="/404" replace /> },
      ],
    },
  ]);
}

const NotFound = Loadable(lazy(() => import("../pages/404/Page404")));
const HomePage = Loadable(lazy(() => import("../pages/Home/Homepage")));
const ProductPage = Loadable(
  lazy(() => import("../pages/Products/ProductPage"))
);
const CategoryPage = Loadable(
  lazy(() => import("../pages/Categories/Categories"))
);
const OrderPage = Loadable(lazy(() => import("../pages/Orders/OrderPage")));
